export function getGroupItemVisualRows(instance, groupRow) {
  const groupValue = instance.getDataAtRowProp(groupRow, 'groupValue');
  const physicalGroupRow = instance.toPhysicalRow(groupRow);
  const nextGroupRowIndex = instance.getSourceData().slice(physicalGroupRow)
    .findIndex(item => item.group && item.groupValue !== groupValue);

  const itemStart = groupRow + 1;
  const itemEnd = nextGroupRowIndex === -1
    ? instance.toVisualRow(instance.countRows()) : groupRow + nextGroupRowIndex;

  return [...Array(itemEnd - itemStart).keys()].map(i => i + itemStart);
}

export function getGroupItemPhysicalRows(instance, groupRow) {
  return getGroupItemVisualRows(instance, groupRow)
    .map(row => instance.toPhysicalRow(row));
}
